import styled from 'styled-components'
import { Outlet } from 'react-router-dom'

import { AccountCircle, AddCircleOutlineRounded, PublicRounded } from '@mui/icons-material'

import Sidebar, { type NavItem } from '../Sidebar'
import Auth from '/components/auth/auth'

const getNavItems = (): NavItem[] => {
  const items: NavItem[] = [
    {
      to: 'explore',
      icon: <PublicRounded />,
      label: 'Explore'
    },
    {
      to: 'my-apps',
      icon: <AccountCircle />,
      label: 'My Apps'
    }
  ]

  if (Auth.isSignedIn) {
    items.push(
      { divider: true },
      {
        to: '/apps/create-app',
        icon: <AddCircleOutlineRounded />,
        label: 'Create App'
      }
    )
  }

  return items
}

export default function Apps() {
  return (
    <Root>
      <Sidebar items={getNavItems()} />

      <Main>
        <Outlet />
      </Main>
    </Root>
  )
}


const Root = styled.div`
  display: flex;
  height: 100%;
`

const Main = styled.div`
  padding: 0 20px;
  flex-grow: 1;
  overflow-y: auto;
`